<!--  <input id="test1" type="text" formControlName="test1">-->
<!--  <input id="test1" type="text" FormControlName="test2">-->


<!--<p>Form Status: {{ test1.status }}</p>-->
<!--<pre>{{ test1.value |json}}</pre>-->
<div class="formContainer" [formGroup]="informationenForm">
  <!--  <p>Form Status: {{ informationenForm.status }}</p>-->
  <!-- <pre>{{ informationenForm.value |json}}</pre>-->
  <!--  {{ informationenForm.controls.test1.value}}-->
  <!--  <mat-card>-->
  <h2>Proben</h2>
  <div class="inputGruppe">
    <mat-form-field>
      <mat-label>Angaben zur Probe</mat-label>
      <mat-select formControlName="angabenZurProbe" id="angabenZurProbeSelect">
        <mat-option *ngFor="let angabenZurProbeOption of angabenZurProbeOptions"
                    [value]="angabenZurProbeOption">{{ angabenZurProbeOption }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="informationenForm.controls['angabenZurProbe'].invalid && (informationenForm.controls['angabenZurProbe'].dirty || informationenForm.controls['angabenZurProbe'].touched)"
        class="alert">
        <div *ngIf="informationenForm.controls['angabenZurProbe'].errors?.['required']">
          Bitte machen Sie Angaben zur Probe
        </div>
      </mat-error>

    </mat-form-field>
    <!--  </div>-->
    <!--  <div>-->
    <mat-form-field>
      <mat-label>Titel des Projekts / der Probenuntersuchung</mat-label>
      <input type="text" formControlName="projektTitel" matInput>
      <mat-error
        *ngIf="informationenForm.controls['projektTitel'].invalid && (informationenForm.controls['projektTitel'].dirty || informationenForm.controls['projektTitel'].touched)"
        class="alert">
        <div *ngIf="informationenForm.controls['projektTitel'].errors?.['required']">
          Bitte geben Sie einen Titel ein
        </div>
      </mat-error>
    </mat-form-field>
  </div>
  <!--  </mat-card>-->
  <!--  <div class="mat-card">-->
  <!--  <mat-card>-->
  <h2>Einsender</h2>
  <div class="inputGruppe">
    <mat-form-field>
      <mat-label>Name</mat-label>
      <input type="text" formControlName="einsenderName" matInput>
      <mat-error
        *ngIf="informationenForm.controls['einsenderName'].invalid && (informationenForm.controls['einsenderName'].dirty || informationenForm.controls['einsenderName'].touched)"
        class="alert">
        <div *ngIf="informationenForm.controls['einsenderName'].errors?.['required']">
          Bitte geben Sie einen Namen ein
        </div>
      </mat-error>
    </mat-form-field>
    <!--  </div>-->
    <!--    <div>-->
    <mat-form-field>
      <mat-label>E-Mail</mat-label>
      <input type="email" formControlName="email" matInput>
      <mat-error
        *ngIf="informationenForm.controls['email'].invalid && (informationenForm.controls['email'].dirty || informationenForm.controls['email'].touched)"
        class="alert">
        <div>
          Bitte geben Sie eine gültige E-Mail-Adresse ein
        </div>
      </mat-error>
    </mat-form-field>
    <!--    </div>-->
    <!--    <div>-->
    <mat-form-field>
      <mat-label>Telefon</mat-label>
      <input type="text" formControlName="telefon" matInput>
      <mat-error
        *ngIf="informationenForm.controls['telefon'].invalid && (informationenForm.controls['telefon'].dirty || informationenForm.controls['telefon'].touched)"
        class="alert">
        <div *ngIf="informationenForm.controls['telefon'].errors?.['required']">
          Bitte geben Sie eine Telefonnummer ein
        </div>
      </mat-error>
    </mat-form-field>
    <!--    </div>-->
    <!--    <div>-->
    <mat-form-field>
      <mat-label>Postanschrift</mat-label>
      <textarea formControlName="adresse" matInput>
      </textarea>
      <mat-error
        *ngIf="informationenForm.controls['adresse'].invalid && (informationenForm.controls['adresse'].dirty || informationenForm.controls['adresse'].touched)"
        class="alert">
        <div *ngIf="informationenForm.controls['adresse'].errors?.['required']">
          Bitte geben Sie eine gültige Adresse ein
        </div>
      </mat-error>
    </mat-form-field>
    <!--    </div>-->
    <!--    <div>-->
    <mat-form-field>
      <mat-label>Verantwortliche/r Wissenschaftliche/r Mitarbeiter/in
      </mat-label>
      <mat-select formControlName="verantwortlicheMitarbeitende">
        <mat-option *ngFor="let verantwortendeMitarbeiterInOption of verantwortendeMitarbeiterInOptions"
                    [value]="verantwortendeMitarbeiterInOption">{{ verantwortendeMitarbeiterInOption.name }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="informationenForm.controls['verantwortlicheMitarbeitende'].invalid && (informationenForm.controls['verantwortlicheMitarbeitende'].dirty || informationenForm.controls['verantwortlicheMitarbeitende'].touched)"
        class="alert">
        <div *ngIf="informationenForm.controls['verantwortlicheMitarbeitende'].errors?.['required']">
          Bitte wählen Sie eine Option aus
        </div>
      </mat-error>
    </mat-form-field>
    <!--    </div>-->
  </div>

  <!--  </mat-card>-->
  <h2>Zeitrahmen (Datum)</h2>
  <div class="inputGruppe">
    <mat-form-field>
      <mat-label>Von</mat-label>
      <input formControlName="von" matInput [matDatepicker]="vonPicker">
      <mat-datepicker-toggle matIconSuffix [for]="vonPicker"></mat-datepicker-toggle>
      <mat-datepicker #vonPicker></mat-datepicker>
      <mat-error
        *ngIf="informationenForm.controls['von'].invalid && (informationenForm.controls['von'].dirty || informationenForm.controls['von'].touched)"
        class="alert">
        <div *ngIf="informationenForm.controls['von'].errors?.['required']">
          Bitte geben Sie ein Datum ein
        </div>
      </mat-error>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Bis</mat-label>
      <input type="text" formControlName="bis" matInput [matDatepicker]="bisPicker">
      <mat-datepicker-toggle matIconSuffix [for]="bisPicker"></mat-datepicker-toggle>
      <mat-datepicker #bisPicker></mat-datepicker>
      <mat-error
        *ngIf="informationenForm.controls['bis'].invalid && (informationenForm.controls['bis'].dirty || informationenForm.controls['bis'].touched)"
        class="alert">
        <div *ngIf="informationenForm.controls['bis'].errors?.['required']">
          Bitte geben Sie ein Datum ein
        </div>
      </mat-error>
    </mat-form-field>
  </div>
  <h2>Zusätzliche Informationen</h2>
  <div class="inputGruppe">
<!--    <mat-form-field>-->
<!--      <mat-label>Probenanzahl</mat-label>-->
<!--      <input type="text" formControlName="probenanzahl" matInput>-->
<!--      <mat-error-->
<!--        *ngIf="informationenForm.controls['probenanzahl'].invalid && (informationenForm.controls['probenanzahl'].dirty || informationenForm.controls['probenanzahl'].touched)"-->
<!--        class="alert">-->
<!--        <div *ngIf="informationenForm.controls['probenanzahl'].errors?.['required']">-->
<!--          Bitte geben Sie eine Zahl ein-->
<!--        </div>-->
<!--      </mat-error>-->
<!--    </mat-form-field>-->
    <!--  </div>-->
    <!--  <div>-->
   <!--    neues Material field mit extra option-->
    <mat-form-field>
      <mat-label>Material</mat-label>
      <mat-select [(value)]="materialSelected"  formControlName="material">
        <mat-option *ngFor="let materialOption of materialOptions" [value]="materialOption">
          {{ materialOption.label }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="informationenForm.controls['material'].invalid && (informationenForm.controls['material'].dirty || informationenForm.controls['material'].touched)"
        class="alert">
        <div *ngIf="informationenForm.controls['material'].errors?.['required']">
          Bitte wählen Sie eine Option aus
        </div>
      </mat-error>
    </mat-form-field>
    <!--  </div>-->
    <div *ngIf='this.materialSelected.verstecktesDivAnzeigen' id="materialZusatzfelder">
      <!--    <div>-->
      <mat-form-field style="width:100%">
        <mat-label>weitere Angaben zum Material</mat-label>
        <textarea formControlName="weitereAngabenSonstige" matInput>
      </textarea>
      </mat-form-field>
      <!--          </div>-->
    </div>

    <!--  </div>-->
    <!--  <div>-->
<!--    <mat-form-field>-->
<!--      <mat-label>Untersuchungsart</mat-label>-->
<!--      <input type="text" formControlName="untersuchungsart" matInput>-->
<!--      <mat-error-->
<!--        *ngIf="informationenForm.controls['untersuchungsart'].invalid && (informationenForm.controls['untersuchungsart'].dirty || informationenForm.controls['untersuchungsart'].touched)"-->
<!--        class="alert">-->
<!--        <div *ngIf="informationenForm.controls['untersuchungsart'].errors?.['required']">-->
<!--          Bitte wählen Sie eine Option aus-->
<!--        </div>-->
<!--      </mat-error>-->
<!--    </mat-form-field>-->
      </div>
  <h2>Rechnungsinformationen</h2>
  <div class="inputGruppe">
    <!--    <div>-->
      <mat-form-field>
        <mat-label>Abrechnung</mat-label>
        <mat-select [(value)]="abrechnungSelected" formControlName="abrechnung">
          <mat-option *ngFor="let abrechnungOption of abrechnungOptions" [value]="abrechnungOption">
            {{ abrechnungOption.label }}
          </mat-option>
        </mat-select>
        <mat-error
          *ngIf="informationenForm.controls['abrechnung'].invalid && (informationenForm.controls['abrechnung'].dirty || informationenForm.controls['abrechnung'].touched)"
          class="alert">
          <div *ngIf="informationenForm.controls['abrechnung'].errors?.['required']">
            Bitte wählen Sie eine Option aus
          </div>
        </mat-error>
      </mat-form-field>
      <!--    </div>-->
      <!--      <div *ngIf='this.abrechnungSelected.verstecktesDivAnzeigen' id="abrechnungZusatzfelder">-->
      <!--      <div class="inputGruppe" id="abrechnungZusatzfelder">-->
      <mat-form-field *ngIf='this.abrechnungSelected.verstecktesDivAnzeigen'>
          <mat-label>Kostenstelle</mat-label>
          <input type="text" formControlName="kostenstelle" matInput>
        </mat-form-field>
        <mat-form-field *ngIf='this.abrechnungSelected.verstecktesDivAnzeigen'>
          <mat-label>Name</mat-label>
          <input type="text" formControlName="rechnungsadresseName" matInput>
        </mat-form-field>
        <mat-form-field *ngIf='this.abrechnungSelected.verstecktesDivAnzeigen'>
          <mat-label>Anschrift</mat-label>
          <textarea type="textfield" formControlName="rechnungsadresseAnschrift" matInput></textarea>
        </mat-form-field>
      </div>
<!--    </div>-->
  <h2>Zusatzinformationen</h2>
  <div class="inputGruppe">
        <mat-form-field>
      <mat-label>Fragestellung</mat-label>
      <textarea formControlName="fragestellung" matInput>
      </textarea>
          <mat-error
            *ngIf="informationenForm.controls['fragestellung'].invalid && (informationenForm.controls['fragestellung'].dirty || informationenForm.controls['fragestellung'].touched)"
            class="alert">
            <div *ngIf="informationenForm.controls['fragestellung'].errors?.['required']">
              Bitte füllen Sie dieses Feld aus
            </div>
          </mat-error>
    </mat-form-field>

        <!--  </div>-->
        <!--  <div>-->
    <mat-form-field>
      <mat-label>Weitere Angaben</mat-label>
      <mat-select [(value)]="weitereAngabenSelected"  formControlName="weitereAngaben">
        <mat-option *ngFor="let weitereAngabenOption of weitereAngabenOptions" [value]="weitereAngabenOption">
          {{ weitereAngabenOption.label }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="informationenForm.controls['weitereAngaben'].invalid && (informationenForm.controls['weitereAngaben'].dirty || informationenForm.controls['weitereAngaben'].touched)"
        class="alert">
        <div *ngIf="informationenForm.controls['weitereAngaben'].errors?.['required']">
          Bitte wählen Sie eine Option aus
        </div>
      </mat-error>
    </mat-form-field>
    <!--  </div>-->
    <div *ngIf='this.weitereAngabenSelected.verstecktesDivAnzeigen' id="weitereAngabenZusatzfelder">
      <!--    <div>-->
      <mat-form-field>
        <mat-label>Weitere Angaben</mat-label>
        <textarea formControlName="weitereAngabenSonstige" matInput>
      </textarea>
      </mat-form-field>
<!--          </div>-->
    </div>
  </div>
  <!--  </div>-->
</div>
